import { Component, ErrorInfo, ReactNode } from 'react';
import i18n from '../../i18n';
import { Sentry } from '../../utils/sentry';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
    // No-op when the DSN isn't configured (dev), so this is always safe
    Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          position: 'fixed', inset: 0, display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          background: '#020617', color: '#fff', fontFamily: 'sans-serif', padding: 24, textAlign: 'center',
        }}>
          <h2 style={{ marginBottom: 8 }}>{i18n.t('common:error.title')}</h2>
          <p style={{ color: '#94a3b8', fontSize: 14, marginBottom: 20 }}>
            {this.state.error.message || i18n.t('common:error.fallbackMessage')}
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              border: '1px solid rgba(96,165,250,.5)', background: 'rgba(37,99,235,.3)',
              color: '#fff', borderRadius: 10, padding: '10px 20px', cursor: 'pointer', fontSize: 14,
            }}
          >
            {i18n.t('common:actions.reload')}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
